import { Badge, Box, Chip, Typography, useTheme } from '@mui/material';
import React from 'react';
import { STATUS_DOT_SIZE } from 'v2/constants';

export type CardChipColor = 'secondary' | 'error' | 'warning' | 'success';

interface Props {
  label: string;
  color: CardChipColor;
}

const BADGE_BOX_SIZE = 14;
const CHIP_MAX_WIDTH = 170;

const CardChip: React.FC<Props> = ({ label, color }) => {
  const theme = useTheme();
  const dotColor = theme.palette[color].main;

  return (
    <Chip
      label={<Typography variant="caption">{label}</Typography>}
      variant="filled"
      size="small"
      color={color}
      sx={{
        maxWidth: CHIP_MAX_WIDTH,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        '& .MuiChip-label': { color: theme.palette[color].light }
      }}
      icon={
        <Badge
          variant="dot"
          overlap="circular"
          sx={{
            '& .MuiBadge-badge': {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              transform: 'translate(-50%, -50%)',
              backgroundColor: dotColor
            },
            '& .MuiBadge-dot': { width: STATUS_DOT_SIZE, height: STATUS_DOT_SIZE }
          }}
        >
          <Box sx={{ width: BADGE_BOX_SIZE, height: BADGE_BOX_SIZE }} />
        </Badge>
      }
    />
  );
};

export default CardChip;
